<template>
  <div class="party-card-grid-wrap">
    <div class="party-card-grid">
      <div
        v-for="item in front.partyListItems"
        :key="item.entryId || item.title"
        class="party-media-card-item"
      >
        <button
          type="button"
          class="party-media-card"
          @click="front.openPartyEntry(item)"
        >
          <div
            class="party-media-card-cover"
            :style="coverStyle(item)"
            aria-hidden="true"
          />
          <div class="party-media-card-body">
            <strong>{{ item.title }}</strong>
            <span>{{ item.summary || item.date || '暂无摘要' }}</span>
          </div>
        </button>
        <div v-if="front.entryAttachments(item).length" class="party-card-files">
          <button
            v-for="(file, index) in front.entryAttachments(item)"
            :key="file.id || file.url || index"
            type="button"
            class="party-file-link"
            @click="front.downloadEntryAttachment(item, file)"
          >
            {{ front.attachmentLabel(file, index, front.entryAttachments(item).length) }}
          </button>
        </div>
      </div>
      <p v-if="!front.partyListItems.length" class="muted-copy">暂无已发布内容，请在管理后台维护</p>
    </div>
    <FrontPagination
      :page-num="front.partyListPageNum"
      :page-size="front.partyListPageSize"
      :total="front.partyListTotal"
      @change="page => front.changePartyListPage(page)"
    />
  </div>
</template>

<script>
import FrontPagination from '../common/FrontPagination.vue'

export default {
  name: 'PartyCardGrid',
  components: { FrontPagination },
  inject: ['front'],
  methods: {
    coverStyle(item) {
      const raw = (item && (item.coverUrl || item.mediaUrl)) || ''
      const url = raw ? this.front.resolvePublicDisplayUrl(raw) : ''
      if (!url) {
        return { background: 'linear-gradient(135deg, #f5e6e8, #f0d5d9)' }
      }
      return {
        backgroundImage: `url(${url})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }
    }
  }
}
</script>
